import React, { useEffect, useState } from "react";
import "./MessageCodes.css";

const MessageA1i = (props) => {
  const [onSelect, setOnSelect] = useState(false);

  useEffect(() => {
    props.setisSubscriber(false);
  }, []);

  const handleClick = () => {
    if (!props.disable) {
      const data = JSON.parse(localStorage.getItem("inputValue"));
      let input;
      
      if (data && props?.item?.text === 'Submit') {
        localStorage.removeItem("inputValue");
        input = data?.key1;
        props?.addMessages(input, props?.item?.code ,props?.item?.text );
        setOnSelect(true);
      } else if (!data && props?.item?.text === 'Submit') {
        return;
      } else {
        input = props?.item?.text;
        props?.addMessages(null, props?.item?.code ,props?.item?.text);
        setOnSelect(true);
      }
    }
  };

  return (
    !props?.loader && (
      <div className="a1-wrap" style={{ width: "fit-content", margin: '6px', cursor: 'pointer' }}>
        <div
          className={
            !onSelect
              ? "chat-label action-tab"
              : "chat-label-select action-tab"
          }
          id="main-tab1"
          style={{ color: props.disable && "grey" }}
          onClick={handleClick}
        >
          {props?.item?.text}
        </div>
      </div>
    )
  );
};

export default MessageA1i;
